function shouldIgnoreCardClick(target: Element): boolean {
  return Boolean(
    target.closest('a, button, input, select, textarea, [role="button"], [role="link"]')
  );
}

export default function initRelatedProductsBlock(root: HTMLElement): void {
  root.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element) || shouldIgnoreCardClick(target)) return;

    const card = target.closest<HTMLElement>('[data-product-card-link]');
    const url = card?.dataset.productCardLink;
    if (!url) return;

    window.location.href = url;
  });
}
